module.exports = __webpack_public_path__ + "media/images/crypto/2-fe7bc4283ffbf49553786d97850539d1.png";